<template>
  <div
    class="d-flex justify-content-center cursor-pointer"
    v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }"
    :title=card_details>
    <font-awesome-icon icon="credit-card" />
  </div>
</template>

<script>
export default {
  props: {
    card_details: {
      type: String,
      required: true
    }
  }
}
</script>
